module.exports = __webpack_public_path__ + "static/media/portfolio-1.6f8be4e7.webp";